import StoredArticle from "@models/articles/StoredArticle";
import Configuration from "@models/project/Configuration";

import Unit from "@models/building/Unit";

const accessorygroups = {
  Verteilerkasten_Zuluft: 16,
  Verteilerkasten_Abluft: 17,
  Lueftungsrohr: 18,
  Sonstiges_Zubehoer: 19,
  KWL_Multi_Zone_Box: 20,
  IsoPipe_Rohre_Boegen_und_Verbinder: 21,
  IsoPipe_Formstuecke: 22,
  IsoPipe_Fassadenblenden: 23,
  IsoPipe_Dachdurchfuehrungen: 24,
  IsoPipe_Schalldaempfer: 25,
  IsoPipe_Sonstiges_Zubehoer: 26,
  KWL_HygroBox: 27,
  Sole_Erdwaermetauscher_SEWT: 28,
  Luft_Erdwaermetauscher_LEWT: 29,
  Ueberstroemelemente: 30,
  Verschlussklappen_Verbindungselemente: 31,
  Steuerung_Regelung: 32,
  Reinigungsset: 33,
};

export function filterUnitDevice(article, unit) {
  if (!article) return false;
  const maxAirvolume = Math.max(
    unit.airvolume.totalSupplyAir,
    unit.airvolume.totalExhaustAir
  );
  if (maxAirvolume > article.getMaxDeviceAirvolume(unit.installation.ewt))
    return false;
  if (unit.deviceFilter[4] == 1) {
    if (maxAirvolume < article.getMinDeviceAirvolume()) return false;
  }
  if (unit.deviceFilter[0] != 0) {
    if (article.getInstallationPosition() != unit.deviceFilter[0]) return false;
  }
  if (unit.deviceFilter[1] != 0 && "connection" in article) {
    if (article.connection != unit.deviceFilter[1] && article.connection != "U")
      return false;
  }
  if (unit.deviceFilter[2] != 0 && "enthalpie" in article) {
    if (article.enthalpie != unit.deviceFilter[2]) return false;
  }
  if (unit.deviceFilter[3] != 0 && "passivhouse" in article) {
    if (article.passivhouse != unit.deviceFilter[3]) return false;
  }
  return true;
}

export function filterUnitEquipment(
  article,
  unitId,
  pipeAmmount,
  accessorygroupId,
  distributors = null
) {
  let showArticle = true;
  switch (parseInt(accessorygroupId)) {
    case accessorygroups.Verteilerkasten_Zuluft:
    case accessorygroups.Verteilerkasten_Abluft:
      showArticle = filterDistributors(
        article,
        unitId,
        distributors,
        accessorygroupId
      );
      break;
    case accessorygroups.Lueftungsrohr:
    case accessorygroups.Sonstiges_Zubehoer:
      showArticle = filterPipeProfile(article, unitId);
      break;
    case accessorygroups.KWL_Multi_Zone_Box:
      return false;
      //setMultiZoneBoxArticles(unitId);
      break;
    case accessorygroups.IsoPipe_Fassadenblenden:
    case accessorygroups.IsoPipe_Dachdurchfuehrungen:
      showArticle = filterFassadenblende(article, unitId);
      break;
    case accessorygroups.IsoPipe_Rohre_Boegen_und_Verbinder:
    case accessorygroups.IsoPipe_Formstuecke:
    case accessorygroups.IsoPipe_Schalldaempfer:
    case accessorygroups.IsoPipe_Sonstiges_Zubehoer:
    case accessorygroups.Verschlussklappen_Verbindungselemente:
      showArticle = filterIsoPipeArticles(article, unitId);
      break;
    case accessorygroups.KWL_HygroBox:
      showArticle = filterHygroBox(article, unitId);
      break;
    case accessorygroups.Sole_Erdwaermetauscher_SEWT:
    case accessorygroups.Luft_Erdwaermetauscher_LEWT:
      showArticle = filterEwtArticles(article, unitId);
      break;
  }
  return showArticle;
}

function filterDistributors(article, unitId, distributors, accessorygroupId) {
  if (!distributors) return false;
  let show = false;
  distributors.forEach((distributor) => {
    if (show === true) return;
    if (article.getFeatureValueById(47) > distributor.pipes) return;
    if (article.getFeatureValueById(48) < distributor.pipes) return;

    if (distributor.profile == 63 && !article.checkFeatureValue(12, 63)) {
      return;
    }
    if (distributor.profile == 51 && !article.checkFeatureValue(12, 51)) {
      return;
    }
    if ((distributor.profile == 75 || distributor.profile == "mixed") && !article.checkFeatureValue(12, 75)) {
      return;
    }
    show = true;
  });
  return show;
}


function filterPipeProfile(article, unitId) {
  const unit = Unit.find(unitId);
  if (!unit) return false;

  const pipeProfile = unit.getPipeProfile();
  if (pipeProfile == 63) {
    if (!article.checkFeatureValue(12, 63)) return false;
  }
  if (pipeProfile == "mixed") {
    if (article.checkFeatureValue(12, 63)) return false;
  }
  if (pipeProfile == 51) {
    if (!article.checkFeatureValue(12, 51)) return false;
  }
  if (pipeProfile == 75) {
    if (!article.checkFeatureValue(12, 75)) return false;
  }
  return true;
}

function filterIsoPipeArticles(article, unitId) {
  const device = StoredArticle.query()
    .where("unit_id", unitId)
    .where("accessorygroup_id", 1)
    .with(["article.features"])
    .first();
  if (!device || !device.article) return false;
  var dn = device.article.getFeatureValueById(5);
  if (!dn) return false;
  if (article.article_id == 64 || article.article_id == 65) {
  }
  if (!article.checkFeatureValue(5, dn)) return false;
  return true;
}

function filterEwtArticles(article, unitId) {
  const unit = Unit.query()
    .where("id", unitId)
    .with(["systemselection", "installation"])
    .first();
  if (!unit) return;
  if (unit.systemselection.ewtSystem != 1) return false;
  if (unit.installation.ewt != 1 && unit.installation.ewt != 2) return false;
  if (
    unit.installation.ewt == 1 &&
    article.accessorygroup.accessorygroups_id == 28
  )
    return false;
  if (
    unit.installation.ewt == 2 &&
    article.accessorygroup.accessorygroups_id == 29
  )
    return false;
  return true;
}

/**
 *
 * Anschlusstyp AU/FO:
 *    1 = Wand/Wand,
 *    2 = Wand/Dach,
 *    3 = Dach/Wand,
 *    4 = Dach/Dach,
 *    5 = -/Wand LEWT,
 *    6 = -/Dach LEWT,
 *    7 = Wand/Wand SEWT,
 *    8 = Wand/Dach SEWT
 *  Au/Fo:
 *    1 = Wand,
 *    2 = Dach
 *  EWT:
 *    1 = LEWT,
 *    2 = SEWT,
 *  Features Anschlusstyp = 46
 *
 */
function filterFassadenblende(article, unitId) {
  const unit = Unit.query()
    .where("id", unitId)
    .with(["systemselection", "installation"])
    .first();

  if (
    !(
      unit.installation.au == 0 ||
      unit.installation.au == 1 ||
      unit.installation.au == 2
    )
  )
    return false;
  if (!(unit.installation.fo == 1 || unit.installation.fo == 2)) return false;

  const device = StoredArticle.query()
    .where("unit_id", unitId)
    .where("accessorygroup_id", 1)
    .with(["article.features"])
    .first();
  if (!device || !device.article) return false;
  var dn = device.article.getFeatureValueById(5);
  if (!dn) return false;
  if (!article.checkFeatureValue(5, dn)) return false;

  if (unit.installation.ewt == 1) {
    if (unit.installation.au == 0 && unit.installation.fo == 1) {
      if (!article.checkFeatureValue(46, 5)) return false;
      return true;
    }
    if (unit.installation.au == 0 && unit.installation.fo == 2) {
      if (!article.checkFeatureValue(46, 6)) return false;
      return true;
    }
  }
  if (unit.installation.ewt == 2) {
    if (unit.installation.au == 1 && unit.installation.fo == 1) {
      if (!article.checkFeatureValue(46, 7)) return false;
      return true;
    }
    if (unit.installation.au == 1 && unit.installation.fo == 2) {
      if (!article.checkFeatureValue(46, 8)) return false;
      return true;
    }
  }

  if (unit.installation.au == 1 && unit.installation.fo == 1) {
    if (!article.checkFeatureValue(46, 1)) return false;
    return true;
  }
  if (unit.installation.au == 1 && unit.installation.fo == 2) {
    if (!article.checkFeatureValue(46, 2)) return false;
    return true;
  }
  if (unit.installation.au == 2 && unit.installation.fo == 1) {
    if (!article.checkFeatureValue(46, 3)) return false;
    return true;
  }
  if (unit.installation.au == 2 && unit.installation.fo == 2) {
    if (!article.checkFeatureValue(46, 4)) return false;
    return true;
  }
}

// Vol. max. => Feature 27 || Vol. min. => Feature 26
function filterHygroBox(article, unitId) {
  const unit = Unit.query().where("id", unitId).with(["airvolume"]).first();
  const maxAirvolume = Math.max(
    unit.airvolume.totalSupplyAir,
    unit.airvolume.totalExhaustAir
  );

  if (
    article.getFeatureValueById(26) == null ||
    article.getFeatureValueById(26) > maxAirvolume
  )
    return false;
  if (
    article.features.some(
      (feature) => feature.feature_id == 27 && feature.value >= maxAirvolume
    )
  )
    return true;
  return false;
}

//40 airType => 1 Abluft, 2 Zuluft, 3 Überström |39 Position => 1 Boden, 2 Wand, 3 Decke | 12 pipeProfile => 51, 63, 75
export function valveFilter(article, room, valve, pipeProfile) {
  if (!article) return false;
  if (!article.checkFeatureValue(40, room.airType)) return false;
  if (!article.checkFeatureValue(39, valve.valvesPosition)) return false;
  if (!article.checkFeatureValue(12, pipeProfile)) return false;
  if (article.features.some((feature) => feature.feature_id == 42)) {
    if (!article.checkFeatureValue(42, room.type)) return false;
  }
  return true;
}

export function filterRoomCombiDevice(article, room, devicePackageId) {
  if (!article) return false;

  if (devicePackageId == 21) {
    if (room.deviceType == 0 && article.id != 727) return false;
    if (room.deviceType == 1 && article.id == 727) return false;
    if (!article.checkFeatureValue(39, room.deviceInstallation)) return false;
  } else {
    const installationPosition = article.getFeatureValueById(39);
    if (installationPosition == null) return true;
    if (!article.checkFeatureValue(39, room.deviceInstallation)) return false;
    if (!article.checkFeatureValue(39, room.mountingPosition)) return false;
  }
  return true;
}

export function filterRoomCombiEquipment(article, unit, room) {
  if (!article) return false;

  if (room.deviceInstallation !== 4 && (article.id === 344 || article.id === 351)) return true

  // check when article has Feature 39 (installationPosition) if it has the same value as the room
  if (article.features.some((feature) => feature.feature_id == 39)) {
    if (!article.checkFeatureValue(39, room.deviceInstallation)) return false;
  }
  if (article.features.some((feature) => feature.feature_id == 46)) {
    if (!article.checkFeatureValue(46, room.mountingPosition)) return false;
  }
  return true;
}

export function filterRoomDevice(article, room, devicePackageId) {
  if (!article) return false;
  // if room ltm is != 2
  if (room.ventilationMeasure !== 2) {
    // then no filter is needed, return true
    return true;
  }

  if (devicePackageId === 14) {
    if (room.deviceInstallation === 14 && (
      article.id !== 160 && article.id !== 161 && article.id !== 195 && article.id !== 196 && article.id !== 197 && article.id !== 198
    )) {
      return false;
    }
    if (room.deviceInstallation !== 14 && (
      article.id === 160 || article.id === 161 || article.id === 195 || article.id === 196 || article.id === 197 || article.id === 198
    )) {
      return false;
    }
    if (room.deviceInstallation === 5 && (article.id !== 609 && article.id !== 610)) {
      return false;
    }
    if (room.deviceInstallation !== 5 && (article.id === 609 || article.id === 610)) {
      return false;
    }

    if (room.airvolume.ald >= 30 && (article.id === 198)) {
      article.quantity = 2;
    }
  }

  //article has features 49, 50 (min/max Vol 4 Pa (with fireplace)) and 51, 52 (min/max Vol 8 Pa (without fireplace))
  // check if unit has fireplace
  let minFeature = 51;
  let maxFeature = 52;
  if (room.unit.fireplace === 1) {
    minFeature = 49;
    maxFeature = 50;
  }

  // get min and max vol from room.features
  const minVol = article.getFeatureValueById(minFeature);
  const maxVol = article.getFeatureValueById(maxFeature);

  //if minVol and maxVol are null, return false
  if (minVol === null || maxVol === null) {
    return false;
  }

  // check if room.airvolume.airvolume is between minVol and maxVol
  return (
    room.airvolume.ald > minVol && room.airvolume.ald <= maxVol
  );
}
